import type { FC } from 'react';
import type { Attachment } from '../../model';
import { MessageFiles } from './files';
import { MessageText } from './text';

export interface MessageBubbleProps {
  variant: 'default' | 'ticket';
  isUser: boolean;
  text?: string | null;
  attachments?: Attachment[] | null;
  onDownload: (id: string, fileName: string) => void;
}

export const MessageBubble: FC<MessageBubbleProps> = ({
  variant,
  isUser,
  text,
  attachments,
  onDownload,
}) => {
  return (
    <div
      className={`${
        variant === 'ticket'
          ? 'bg-white'
          : 'bg-gray-100 border border-gray-200 rounded-2xl p-4'
      } text-gray-900 ${isUser ? 'rounded-tr-none' : 'rounded-tl-none'}`}
    >
      <MessageText text={text} />
      <MessageFiles attachments={attachments} onDownload={onDownload} />
    </div>
  );
};
